//@flow
import merge from 'lodash/merge';
import {
    localeSettingsApi,
    businessUnitLocaleSettingsApi
} from 'common/middleware/api';
import i18n, { enStrings } from 'i18n';
import I18nHelper from 'common/helpers/I18nHelper';
import { addStrings } from 'common/modules/i18n';

type Params = {
    clientId: string,
    language: ?string,
    businessUnitId?: ?string
};

type Response = $FixMe;

class IntlApiActions {
    static fetchI18nStrings(params: Params): Response {
        const localeApi = params.businessUnitId
            ? businessUnitLocaleSettingsApi
            : localeSettingsApi;

        return localeApi.fetch({
            clientId: params.clientId,
            language: params.language ?? 'en-US',
            // only include businiessUnitId when set
            ...(params.businessUnitId
                ? { businessUnitId: params.businessUnitId }
                : null)
        });
    }

    static setUiLocaleApiCall(params: Params): Response {
        return IntlApiActions.fetchI18nStrings(params).then(response =>
            IntlApiActions.setUiLocale(response)
        );
    }

    static setUiLocale(response: Response): Response {
        const mergedResources = merge({}, enStrings, response.stringsMap);
        I18nHelper.setPreferredLanguage(response.language);
        addStrings(i18n, response.language, mergedResources);
        i18n.changeLanguage(response.language);
        return response;
    }
}

export default IntlApiActions;
